import { Modal } from "@nulogy/components";
import usePublishSummaryModal from "hooks/state/usePublishSummaryModal";
import React from "react";
import PublishSummaryModalView from "./PublishSummaryModalView";

export default function PublishSummaryModal() {
  const { close: closeModal, isOpen, data } = usePublishSummaryModal();

  const close = () => {
    closeModal();
  };

  return (
    <Modal ariaHideApp={false} isOpen={isOpen} maxWidth="816px" onRequestClose={close} title="Publish Summary">
      <PublishSummaryModalView summaryData={data} />
    </Modal>
  );
}
